import { getTheme, parseCustomFonts, themeVars } from '@livequiz/shared';

/** Registriert quizweite Eigenschriften per @font-face (aus themeOverrides). */
function injectCustomFonts(overrides?: Record<string, string> | null): void {
  const fonts = parseCustomFonts(overrides);
  const styleId = 'lq-custom-fonts';
  let el = document.getElementById(styleId) as HTMLStyleElement | null;
  if (!el) {
    el = document.createElement('style');
    el.id = styleId;
    document.head.appendChild(el);
  }
  el.textContent = fonts.map((f) => `@font-face{font-family:"${f.family}";src:url("${f.url}");font-display:swap;}`).join('\n');
}

/** Setzt die Theme-Tokens als CSS-Variablen auf <html> und schaltet das Farbschema. */
export function applyTheme(id: string | null | undefined, overrides?: Record<string, string> | null): void {
  const el = document.documentElement;
  const theme = getTheme(id);
  const vars = themeVars(id, overrides);
  for (const [k, v] of Object.entries(vars)) el.style.setProperty(k, v);
  el.style.colorScheme = theme.light ? 'light' : 'dark';
  el.classList.toggle('lq-animated-bg', Boolean(theme.animatedBg) && !overrides?.background);
  injectCustomFonts(overrides);
  // Eigenes Hintergrundbild/GIF (pro Quiz) überschreibt den Verlauf.
  if (overrides?.background) {
    el.style.setProperty('--bg', `center/cover no-repeat url("${overrides.background}")`);
  }
}
